import React from 'react';
import { connect } from 'react-redux';
import { getUserAccessUpdate, getUserSignOut, removeRoom } from '../../services/api';
import { isEmpty } from '../../utilities/methods';

import ButtonCopy from '../Buttons/ButtonCopy';
import UserInfo from './UserInfo';

import "./Navbar.css";

// import avatarDefault from "../../images/avatar_default_white.png";

const Navbar = ({ isRoomHost, roomId, usuarioId, username, roomSocketId }) => {
    const handlerUserSignOut = async () => {
        try {
            if(roomId) {
                await removeRoom(roomId);
            }

            if(usuarioId) {
                await getUserAccessUpdate(usuarioId, false);
            }
        } finally {
            getUserSignOut({ roomSocketId });
        }
    };

    return (
        <div className='row navbar_container'>
            <div className='col-md-4'></div>

            <div className="col-md-4">
                {(isRoomHost && !isEmpty(roomId)) ?
                    <ButtonCopy
                        title="Código da Sala:"
                        text={roomId}
                    /> :
                    <UserInfo
                        username={username}
                    // avatar={(!isEmpty(avatar) && /\.(png|jpe?g|gif|bmp|webp|svg)$/i.test(avatar)) ? avatar : avatarDefault}
                    />
                }
            </div>

            <div className="col-md-4">
                <div className="btn_logout_navbar_content" title='Sair' onClick={handlerUserSignOut}>
                    <span className='item_menu_text'>Sair</span>
                    <span className="material-symbols-outlined item_menu_icon"> logout </span>
                </div>
            </div>
        </div>
    );
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

export default connect(mapStoreToProps)(Navbar);